import { RefObject } from "react";

export const startVideoStream = async (videoRef: RefObject<HTMLVideoElement>): Promise<MediaStream | null> => {
  const videoElement = videoRef.current;
  if (!videoElement) return null;

  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: {
        width: { ideal: 3840 }, // Suggest 4K resolution (or higher)
        height: { ideal: 2160 },
        facingMode: "environment",
      },
    });

    //console.log("Camera stream started:", stream);
    videoElement.srcObject = stream;
    await videoElement.play();
    return stream;
  } catch (error: any) {
    console.error("Error accessing camera:", error);
    if (error.name !== "AbortError") {
      alert("カメラにアクセスできませんでした: " + error.message);
    }
    return null;
  }
};
